/**
 * Bundle "Add package to cart" handler.
 *
 * Intercepts the button click on the product-bundle section, adds each
 * component variant to the cart as its own line item via /cart/add.js,
 * and redirects to the cart. The store's automatic accessory discount
 * is applied server-side.
 */
(function () {
  'use strict';

  function parseIds(raw) {
    if (!raw) return [];
    return raw
      .split(',')
      .map(function (s) { return parseInt(s.trim(), 10); })
      .filter(function (n) { return Number.isFinite(n) && n > 0; });
  }

  function setError(errorEl, message) {
    if (!errorEl) return;
    if (!message) {
      errorEl.hidden = true;
      errorEl.textContent = '';
      return;
    }
    errorEl.hidden = false;
    errorEl.textContent = message;
  }

  function addComponentsToCart(button) {
    var ids = parseIds(button.dataset.bundleComponents);
    var errorEl = button.parentElement
      ? button.parentElement.querySelector('[data-bundle-error]')
      : null;
    var labelEl = button.querySelector('[data-bundle-button-label]');
    var originalLabel = labelEl ? labelEl.textContent : (button.dataset.labelIdle || '');
    var addingLabel = button.dataset.labelAdding || originalLabel;
    var errorGeneric = button.dataset.errorGeneric || '';
    var errorNoComponents = button.dataset.errorNoComponents || '';

    if (ids.length === 0) {
      setError(errorEl, errorNoComponents);
      return;
    }

    setError(errorEl, '');
    button.disabled = true;
    if (labelEl) labelEl.textContent = addingLabel;

    var items = ids.map(function (id) {
      return { id: id, quantity: 1 };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, status: response.status, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var message = (result.data && (result.data.description || result.data.message))
            || errorGeneric;
          throw new Error(message);
        }
        window.location.href = button.dataset.redirect || '/cart';
      })
      .catch(function (err) {
        console.error('[product-bundle] add to cart failed:', err);
        setError(errorEl, err.message || errorGeneric);
        button.disabled = false;
        if (labelEl) labelEl.textContent = originalLabel;
      });
  }

  function init() {
    var buttons = document.querySelectorAll('[data-bundle-add-to-cart]');
    buttons.forEach(function (button) {
      if (button.dataset.bundleBound === '1') return;
      button.dataset.bundleBound = '1';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        addComponentsToCart(button);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
